// extracted by mini-css-extract-plugin
export default {"participant":"LinkInfo_participant__d4InH","icon":"LinkInfo_icon__95JCd"};